import { ref } from '@vue/composition-api';
import { http } from '@article/pixel';
import Tracking from '@/components/commons/Tracking.js';
import LocationService from '@/services/LocationService.js';

const API_URL = process.env.STOREFRONT_SERVER ? `${process.env.MEGASTORE_API_URL}/api/crosssell` : `/api/crosssell`;

export default function useCrossSell() {
  const crossSellProducts = ref([]);

  async function fetchCrossSellProducts(productIds) {
    if (!productIds?.length) {
      return [];
    }

    try {
      const { products, success } = await http.get(API_URL, {
        productIds,
        fetchForExpensiveOnly: true,
        excludeOtherCategoryProducts: true,
        forceCurrencyId: LocationService.getCurrencyId(),
      });

      if (success) {
        crossSellProducts.value = products;
      }
    } catch (error) {
      Tracking.sentryCaptureError(error);
    }

    return crossSellProducts.value;
  }

  return {
    crossSellProducts,
    fetchCrossSellProducts,
  };
}
